var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-button',{staticClass:"mb-2",attrs:{"variant":"danger"},on:{"click":_vm.followLink}},[_vm._v("Login To Portal As "+_vm._s(_vm.type))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }